import { render } from "./DanWeiCompile.vue?vue&type=template&id=7a1743b6"
import script from "./DanWeiCompile.vue?vue&type=script&lang=js"
export * from "./DanWeiCompile.vue?vue&type=script&lang=js"

import exportComponent from "D:\\fxwl\\wx-wl_full\\wx-wl_full\\fxwl\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__